import { render, staticRenderFns } from "./CWage.vue?vue&type=template&id=5379faab"
import script from "./CWage.vue?vue&type=script&lang=js"
export * from "./CWage.vue?vue&type=script&lang=js"
import style0 from "./CWage.vue?vue&type=style&index=0&id=5379faab&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5379faab')) {
      api.createRecord('5379faab', component.options)
    } else {
      api.reload('5379faab', component.options)
    }
    module.hot.accept("./CWage.vue?vue&type=template&id=5379faab", function () {
      api.rerender('5379faab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CWage.vue"
export default component.exports